import timesheetNzReducer from "./reducers/timesheetNzReducer";

export default timesheetNzReducer;
